import { createStyles } from "@mantine/core"

interface OptionsStylesProps {
    shouldReducePadding?: boolean
}

export const useStyles = createStyles((theme, { shouldReducePadding = false }: OptionsStylesProps) => ({
    options: {
        height: "23.5rem",
        maxHeight: "23.5rem",
        overflow: "auto",
        padding: "0",

        "&:hover::-webkit-scrollbar-thumb": {
            background: "rgba(0,0,0,.3)",
            borderRadius: "1rem",
            border: "0.125rem solid rgba(0,0,0,.0)",
            backgroundClip: "padding-box",
            padding: "0.125rem",
        },

        "&::-webkit-scrollbar-thumb": {
            background: "rgba(0,0,0,.2)",
            borderRadius: "1rem",
            border: "0.125rem solid rgba(0,0,0,.0)",
            backgroundClip: "padding-box",
            padding: "0.125rem",
        },

        "&::-webkit-scrollbar-track": {
            background: "transparent",
        },

        "&::-webkit-scrollbar": {
            width: "0.5rem",
            background: "transparent",
        },
    },
    groupContainer: {
        marginTop: "0.75rem",
    },
    groupTitle: {
        padding: "0rem 1rem .5rem",
        background: "white",
        color: theme.colors.gray[6],
        fontSize: ".75rem",
        fontWeight: 500,
        textTransform: "uppercase",
        letterSpacing: ".0625rem",
        lineHeight: 1.25,
        position: "sticky",
        top: 0,
        zIndex: 2,
    },
    option: {
        ".mantine-Radio-body": {
            position: "relative",
        },

        ".mantine-Radio-inner": {
            display: "none",
            position: "absolute",
            right: "1rem",
            top: ".75rem",
            zIndex: 1,
        },

        ".mantine-Radio-radio": {
            border: 0,
            backgroundColor: "transparent",

            "&:checked": {
                backgroundColor: "transparent",
            },
        },

        ".mantine-Radio-labelWrapper": {
            flex: 1,
            position: "relative",
            transition: ".3s ease-in-out",
            transitionProperty: "background-color, color",
            gap: "0.5rem",

            "&:hover": {
                backgroundColor: theme.colors.gray[1],

                ".mantine-Radio-label": {
                    color: "inherit",
                },
            },
        },

        ".mantine-Radio-label": {
            color: theme.colors.gray[7],
            cursor: "pointer",
            fontSize: "1rem",
            lineHeight: 1,
            padding: shouldReducePadding ? ".75rem 0 .75rem 1rem" : ".75rem 1rem",
            transition: "inherit",

            "& p": {
                fontWeight: 500,
                marginBottom: "0.5rem",
            },

            "&: hover": {
                "& div": {
                    color: theme.colors.gray[7],
                },
            },
        },

        ".mantine-Radio-icon": {
            height: "initial",
            inset: 0,
            width: "initial",
        },

        "&[data-checked] .mantine-Radio-label": {
            color: theme.colors.violet[8],
            backgroundColor: theme.colors.violet[1],

            "& div": {
                color: theme.colors.gray[7],
            },
        },

        ".mantine-Spoiler-control": {
            color: theme.colors.violet[8],

            "& svg": {
                width: "0.75rem",
            },

            "&:hover": {
                backgroundColor: "transparent",
            },

            "&:focus": {
                backgroundColor: "transparent",
            },
        },
    },
    description: {
        margin: 0,
        fontSize: ".75rem",
        lineHeight: "normal",
    },
    linkWrapper: {
        padding: ".75rem 1rem",
    },
    link: {
        ".mantine-Button-rightIcon": {
            margin: 0,
        },
    },
    pen: {
        "&&": {
            fontSize: ".75rem",
            width: "initial",
        },
    },
    majorRegionDisabled: {
        backgroundColor: theme.colors.gray[0],
        color: theme.colors.gray[6],
        display: "flex",
        flexDirection: "column",
        gap: ".5rem",
        padding: ".75rem 1rem",
        position: "relative",

        ".major-region-disabled--title": {
            fontSize: "1rem",
            fontWeight: 500,
            lineHeight: 1,
            margin: 0,
        },

        ".major-region-disabled--description": {
            fontSize: ".75rem",
            lineHeight: 1.2,
            margin: 0,

            a: {
                color: theme.colors.violet[6],
            },
        },

        ".major-region-disabled--icon": {
            color: theme.colors.gray[5],
            fontSize: "1rem",
            position: "absolute",
            right: "1rem",
            top: ".75rem",
        },
    },
}))
